export type TAdminWorkspacesListParams = {
  page: number;
  pageSize: number;
  orderBy: string;
  orderType: 'asc' | 'desc';
  search: string;
};

export const adminWorkspacesKeys = {
  all: [{ module: 'adminWorkspaces' }] as const,
  lists: () => [{ ...adminWorkspacesKeys.all[0], scope: 'list' }] as const,
  list: (params: TAdminWorkspacesListParams) => [{ ...adminWorkspacesKeys.lists()[0], params }] as const,
  allList: () => [{ ...adminWorkspacesKeys.all[0], scope: 'allList' }] as const,
  details: () => [{ ...adminWorkspacesKeys.all[0], scope: 'detail' }] as const,
  detail: (workspaceId: string) => [{ ...adminWorkspacesKeys.details()[0], workspaceId }] as const,
  teams: () => [{ ...adminWorkspacesKeys.all[0], scope: 'teams' }] as const,
  teamsByWorkspace: (workspaceId: string) => [{ ...adminWorkspacesKeys.teams()[0], workspaceId }] as const,
};
